import React from 'react';
import Lottie from 'react-lottie';
import { getValueOfCurrentLanguage } from '../../helpers/Utils';
import * as loading from './logi_motion_v3.json';


const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: loading.default,
  };


const Loading = () =>{
    return(
      <div>
				<div className="loading-max-width text-center loading-style  ">
        {/* d-flex justify-content-between align-items-center shadow*/}

            <div className="text-center">
              {/* {getValueOfCurrentLanguage('7030.common.waiteAMoment')} */}
            </div>
            <div className="Lottie">
              <Lottie options={defaultOptions} margin={0} height={100} width={100}/>
            </div>
        </div>
        <div className="backgroundFor" style={{background: "rgba(0, 0, 0, 0)"}}>

        </div>
      </div>
    )
}

export default Loading;